export default __webpack_public_path__ + "static/media/Girls_Jump_Spin.0cd767d4.svg";